import { Fragment, h } from 'preact';
import { useCallback, useEffect, useRef, useState } from 'preact/hooks';
import { EMBED_CLOSED } from '../../../../../types';
import { useOpenDialogsCounter, useRegisterDialog } from '../../../../common/context/DialogContext';
import { usePlayerContext, useStyles } from '../../../../common/hooks';
import { connect, withBreakPoints } from '../../../hoc';
import { BUTTON_SQUARE_SIZE } from '../../../styles';
import { handleCloseModalButton } from '../../../utils/modal';
import Button from '../../common/buttons/Button';
import { Modal } from '../../common/modal';
import { MODAL_BASIC_STYLE, MODAL_CLOSING_BUTTON_STYLE } from '../../common/modal/types';
import EmbedScreen from './EmbedScreen';
import {
  EMBED_DEFAULT_DIALOG_STYLE,
  EMBED_DIALOG_CONTENT_OPENED_STYLE,
  EMBED_DIALOG_CONTENT_STYLE
} from './styles';

const style = {
  container: EMBED_DEFAULT_DIALOG_STYLE,
  content: EMBED_DIALOG_CONTENT_STYLE,
  openedContent: EMBED_DIALOG_CONTENT_OPENED_STYLE
};

function EmbedButton({
  isAd,
  embed,
  waitStart,
  small,
  extraSmall,
  embedKey
}) {
  const player = usePlayerContext();
  const [copied, setCopied] = useState(false);
  const [opened, setOpened] = useState(false);
  const [isOutsideModal, setIsOutsideModal] = useState(null);
  const closeIconRef = useRef(null);
  const iconRef = useRef(null);
  const setStyles = useStyles();

  const closingButtonSize = setStyles({
    extraSmall: { width: 16 },
    'small+medium+large+extraLarge': { width: 24 }
  });

  useRegisterDialog({ id: 'embed', openingMode: 'click', state: [opened, setOpened] });
  useOpenDialogsCounter(opened);

  const embedKeyFetched = useRef(false);
  const fetchEmbedKey = useCallback(() => {
    if (!embedKeyFetched.current) {
      player.requestEmbed();
      embedKeyFetched.current = true;
    }
  }, [embedKeyFetched.current, embedKey]);

  useEffect(() => {
    if (!embedKey) {
      embedKeyFetched.current = false;
    }
  }, [embedKey]);

  useEffect(() => {
    if (opened && closeIconRef.current) {
      setIsOutsideModal(false);
      closeIconRef.current.focus();
    }

    if (!opened) {
      setCopied(false);
    }
  }, [opened, isOutsideModal]);

  const handleCloseModal = (event) => {
    handleCloseModalButton({
      event,
      player,
      currentIconRef: iconRef.current,
      setIsModalOpened: setOpened,
      closedAction: EMBED_CLOSED
    });
  };

  return (
    <Fragment>
      <Button
        hidden={isAd || waitStart || extraSmall || !embed}
        type="icon"
        label="Intégrer"
        ariaLabel="Intégrer"
        forceLabel
        zone="top"
        name="btn-embed"
        openingMode="click"
        icon="embed"
        style={style}
        size={(setStyles(BUTTON_SQUARE_SIZE)).width}
        xs={(small || extraSmall)}
        onClick={() => { fetchEmbedKey(); setOpened(true); }}
        iconRef={iconRef}
      />

      {opened && (
        <Modal
          trap
          show={opened}
          attachedTo="btn-embed"
          styles={MODAL_BASIC_STYLE}
          onChange={(openedState) => {
            setIsOutsideModal(true);
            setOpened(openedState);
          }}
          onEscapeKeyDown={handleCloseModal}
          closingButtonStyle={setStyles(MODAL_CLOSING_BUTTON_STYLE)}
          closeComponent={(
            <Button
              type="icon"
              openingMode="click"
              label="Fermer"
              ariaLabel="Fermer"
              forceLabel
              disableFocus={false}
              zone="top"
              onClick={handleCloseModal}
              size={closingButtonSize.width}
              icon="close"
              xs
              iconRef={closeIconRef}
              name="btn-close-embed"
              ariaHidden={false}
            />
          )}
        >
          <EmbedScreen onCopyFail={() => { setOpened(false); }} copyEmbedIframe={() => setCopied(true)} copied={copied} />
        </Modal>
      )}
    </Fragment>
  );
}

const selector = ({
  media: {
    embed,
    isAd
  },
  ui: { waitStart, embedKey }
}) => ({
  embed, isAd, waitStart, embedKey
});
export default withBreakPoints(connect(selector)(EmbedButton));
